import React, { Fragment } from 'react';

import { useTranslation } from 'react-i18next';

interface ErrorStateProps {
	error?: any;
	resetErrorBoundary?: () => void;
	children?: React.ReactNode;
}
function ErrorState({ children, error }: ErrorStateProps) {
	const { t } = useTranslation();
	return (
		<div className='container error-state'>
			<div className='row'>
				<div className='col-lg-10 col-xxl-8 offset-lg-1 offset-xxl-2'>
					<div className='error-state__wrapper'>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							fill='none'
							viewBox='0 0 24 24'
							strokeWidth='1.5'
							stroke='currentColor'
							className='icon'
						>
							<path
								strokeLinecap='round'
								strokeLinejoin='round'
								d='M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z'
							/>
						</svg>
						<div>
							{children ? (
								children
							) : (
								<Fragment>
									<h1>{t('common.error.occur')}</h1>
									<p className='error-state__message'>{error}</p>
									<p className='error-state__wrapper__retry'>
										{t('common.error.support')}
									</p>
								</Fragment>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default ErrorState;
